import axios from 'axios'
import { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import { axiosApi } from '../../utils/axiosApi'

const useOtherDepartment = () => {

    const [otherDepartmentOptions, setOtherDepartmentOptions] = useState([])
    const [otherDepartmentOptionsById, setOtherDepartmentOptionsById] = useState([])

    // 🔹 Get logged-in user data
    const loginUserData = useSelector((state) => state.loginData.userData)

    useEffect(() => {
        const fetchOtherDepartments = async () => {
            try {
                // 🔹 Payload
                const payload = {
                    departmentName: loginUserData?.department?.[0]?.label || "",
                    departmentId: ""
                }

                const res = await axiosApi(
                    process.env.REACT_APP_BASE_URL + '/department/getAllOtherDepartment',
                    payload
                )

                const data = res?.data?.data || []

                // 🔹 Name based options
                const filterOption = data.map((itm) => ({
                    value: itm.departmentName,
                    label: itm.departmentName
                }))

                // 🔹 ID based options
                const filterOptionById = data.map((itm) => ({
                    value: itm.departmentId,
                    label: itm.departmentName
                }))

                setOtherDepartmentOptions(filterOption)
                setOtherDepartmentOptionsById(filterOptionById)

            } catch (error) {
                console.log("Error fetching other departments:", error)
            }
        }

        // 🔹 Call only when user data available
        if (loginUserData?.department) {
            fetchOtherDepartments()
        }

    }, [loginUserData])

    return { otherDepartmentOptions, otherDepartmentOptionsById }
}

export default useOtherDepartment